import React from 'react';
import clsx from 'clsx';
import CloseIcon from '@mui/icons-material/Close';

type ChipProps = {
  label: string;
  onClick?: () => void;
  className?: string;
  size?: 'small' | 'medium';
  removable?: boolean;
};

export const Chip: React.FC<ChipProps> = ({
  label,
  onClick,
  className = '',
  size = 'small',
  removable = true,
}) => {
  return (
    <div
      className={clsx(
        'flex items-center rounded-full bg-primary text-main cursor-pointer border border-solid border-primary',
        size === 'small' ? 'text-tiny px-3 py-1' : 'text-medium px-4 py-2',
        'hover:opacity-80 transition-opacity duration-150',
        className
      )}
      onClick={onClick}
    >
      <span className="truncate max-w-[100px]">{label}</span>
      {removable && (
        <CloseIcon
          fontSize="inherit"
          className="ml-1 text-main opacity-80 hover:opacity-100"
        />
      )}
    </div>
  );
};

export default Chip;
